import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c90a7044"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c90a7044')) {
      api.createRecord('c90a7044', component.options)
    } else {
      api.reload('c90a7044', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=c90a7044", function () {
      api.rerender('c90a7044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/message-box/src/main.vue"
export default component.exports